import { SwipeableDrawer, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import Util from "../../Util";
import Close from "../../assets/Icon/close.png";
import { useTranslation } from "react-i18next";
import ApiCalling from "../../network/ApiCalling";
import Loader from "../../components/common/Loader";
import Invalid from "../../assets/Icon/invalid.svg";

export const AddNewCurriculum = (props) => {
  const show = props.show;
  const onClose = props.onClose;
  const onSave = props.onSave;
  // console.log("copy", props);
  const copy = props.copy;
  const isAdmin = props.isAdmin;
  const edit = props.edit;
  // console.log("admin", isAdmin);
  const getLanguage = Util.getSelectedLanguage();
  const [alertModal, setIsAlertModal] = useState(false);
  const [isStateUpdated, setIsStateUpdated] = useState(false);
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [status, setStatus] = useState(0);
  const [statusError, setStatusError] = useState("");
  const { t } = useTranslation();
  const [loading, setIsLoading] = useState(false);
  const [gradeData, setGradeData] = useState([]);
  const [gradeId, setGradeId] = useState(0);
  const [gradeError, setGradeError] = useState("");
  const [academicData, setAcademicData] = useState([]);
  const [academicId, setAcademicId] = useState(0);
  const [academicError, setAcademicError] = useState("");
  const [templateList, setTemplateList] = useState([]);
  const [templateId, setTemplateId] = useState(0);
  const [templateError, setTemplateError] = useState("");


  const statusList = [
    { id: 1, value: "Active" },
    { id: 2, value: "Inactive" },
  ];

  const handleSubmit = () => {
    setIsLoading(true);
    setIsStateUpdated(false);
    setNameError("");
    setStatusError("");
    setAcademicError("");
    setGradeError("");
    setTemplateError("");
    let error = false;
    if (name === "") {
      setNameError(t("Name is required"));
      error = true;
      setIsLoading(false);
    }
    if (status === 0) {
      setStatusError(t("Status is required"));
      error = true;
      setIsLoading(false);
    }
    if (isAdmin) {
      if (gradeId === 0) {
        setGradeError("Grade is required");
        error = true;
        setIsLoading(false);
      }
      if (academicId === 0) {
        setAcademicError("Academic Year is required");
        error = true;
        setIsLoading(false);
      }
      if (templateId === 0) {
        setTemplateError("Template is required");
        error = true;
        setIsLoading(false);
      }
    }
    if (!error) {
      let data;
      // if (!isUberAdmin) {
      data = {
        name: name,
        status: Number(status),
        grade_id: gradeId === 0 ? null : gradeId,
        academic_year: academicId === 0 ? null : academicId,
        templateId: Object.keys(copy).length === 0 ? templateId : copy?.id,
        isAdmin: isAdmin,
      };
      if (Object.keys(edit).length === 0) {
        ApiCalling.apiCallBodyDataPost("assessments/add-template", data)
          .then((res) => {
            if (res.data.status) {
              onSave();
              reset();
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else {
        data.id = edit.id;
        ApiCalling.apiCallBodyDataPost("assessments/update-template", data)
          .then((res) => {
            if (res.data.status) {
              onSave();
              reset();
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
      // }
      // console.log(data, copy);
    }
  };

  const reset = () => {
    setName("");
    setNameError("");
    setStatus(0);
    setStatusError("");
    setGradeId(0);
    setGradeError("");
    setAcademicId(0);
    setAcademicError("");
    setTemplateId(0);
    setTemplateError("");
  };

  const getGradeList = async () => {
    ApiCalling.apiCallBodyDataGet("grade/list")
      .then((res) => {
        setGradeData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getGradeList();
    academicList();
    getActiveTemplate();
  }, []);

  const academicList = async () => {
    ApiCalling.apiCallBodyDataGet("academic-year/getActive")
      .then((res) => {
        if (res.data) {
          setAcademicData(res.data);
        } else {
          setAcademicData(null);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getActiveTemplate = async () => {
    ApiCalling.apiCallBodyDataGet("assessments/getActiveTemplate")
      .then((res) => {
        if (res.data) {
          setTemplateList(res.data);
        } else {
          setTemplateList(null);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (Object.keys(copy).length !== 0) {
      setName("");
      setGradeId(copy?.grade_id);
      setAcademicId(copy?.academic_year);
      setTemplateId(copy?.template_id);
      setStatus(copy?.status);
    }
    if (Object.keys(edit).length !== 0) {
      setName(edit?.name);
      setGradeId(edit?.grade_id);
      setAcademicId(edit?.academic_year);
      setTemplateId(edit?.template_id);
      setStatus(edit?.status);
    }
  }, [copy, edit]);

  return (
    <div>
      <SwipeableDrawer
        anchor={getLanguage === "ar" ? "left" : "right"}
        open={show}
        onClose={() => {
          if (isStateUpdated) {
            setIsAlertModal(true);
          } else {
            onClose();
            reset();
            setIsStateUpdated(false);
          }
        }}
        onOpen={() => {}}
      >
        <div
          className="box-area"
          style={{
            position: "relative",
            width: "100%",
            height: "calc(100vh - 64px)",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <Box sx={{ width: "656px", padding: "20px" }} role="presentation">
            <div className="d-flex align-items-center justify-content-between">
              <div className="drawer-header">Add Assessment Template</div>
              <button className="hidden-btn">
                <img
                  src={Close}
                  alt="Close"
                  className="svg-icon"
                  onClick={() => {
                    if (isStateUpdated) {
                      setIsAlertModal(true);
                    } else {
                      onClose();
                      //   setObservationById(null);
                      reset();
                      setIsStateUpdated(false);
                    }
                  }}
                  height={20}
                  width={20}
                />
              </button>
            </div>
            {loading ? (
              <Loader />
            ) : (
              <div className="body mt-3">
                <div className="row mt-2">
                  <div className="col-md-12">
                    <label className="basic-text required">{t("Name")}</label>
                    <input
                      className={`form-control ${
                        nameError.length > 0 ? "input-error" : "custom-input"
                      }`}
                      placeholder={t("Name")}
                      type="text"
                      value={name}
                      onChange={(event) => {
                        setName(event.target.value);
                        setNameError("");
                        setIsStateUpdated(true);
                      }}
                    />
                    {nameError.length > 0 && (
                      <div className="invalid-error px-0">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                          alt="invalid"
                        />
                        {nameError}
                      </div>
                    )}
                  </div>

                  {isAdmin && (
                    <div className="col-md-12 mt-3">
                      <label className="basic-text required">
                        {t("Grade")}
                      </label>
                      <select
                        className={`select-dropdown form-select custom-input ${
                          gradeError.length > 0 ? "input-error" : ""
                        }`}
                        name="grade"
                        value={gradeId}
                        onChange={(event) => {
                          setGradeId(event.target.value);
                          setGradeError("");
                          setIsStateUpdated(true);
                        }}
                      >
                        <option value={0} disabled>
                          {t("Grade")}
                        </option>
                        {gradeData.map((item) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.title}
                            </option>
                          );
                        })}
                      </select>
                      {gradeError.length > 0 && (
                        <div className="invalid-error px-0">
                          <img
                            className="fa fa-exclamation-circle mr-2 invalid-svg"
                            src={Invalid}
                            alt="invalid"
                          />
                          {gradeError}
                        </div>
                      )}
                    </div>
                  )}

                  {isAdmin && (
                    <div className="col-md-12 mt-3">
                      <label className="basic-text required">
                        {t("Academic Year")}
                      </label>
                      <select
                        className={`select-dropdown form-select custom-input ${
                          academicError.length > 0 ? "input-error" : ""
                        }`}
                        name="academic_year"
                        value={academicId}
                        onChange={(event) => {
                          setAcademicId(event.target.value);
                          setAcademicError("");
                          setIsStateUpdated(true);
                        }}
                      >
                        <option value={0} disabled>
                          {t("Academic Year")}
                        </option>
                        {academicData.map((item) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.title}
                            </option>
                          );
                        })}
                      </select>
                      {academicError.length > 0 && (
                        <div className="invalid-error px-0">
                          <img
                            className="fa fa-exclamation-circle mr-2 invalid-svg"
                            src={Invalid}
                            alt="invalid"
                          />
                          {academicError}
                        </div>
                      )}
                    </div>
                  )}

                  {isAdmin && (
                    <div className="col-md-12 mt-3">
                      <label className="basic-text required">
                        {t("Template")}
                      </label>
                      <select
                        className={`select-dropdown form-select custom-input ${
                          templateError.length > 0 ? "input-error" : ""
                        }`}
                        name="template"
                        value={templateId}
                        onChange={(event) => {
                          setTemplateId(event.target.value);
                          setTemplateError("");
                          setIsStateUpdated(true);
                        }}
                        disabled={Object.keys(edit).length !== 0}
                      >
                        <option value={0} disabled>
                          {t("Template")}
                        </option>
                        {templateList.map((item) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                      {templateError.length > 0 && (
                        <div className="invalid-error px-0">
                          <img
                            className="fa fa-exclamation-circle mr-2 invalid-svg"
                            src={Invalid}
                            alt="invalid"
                          />
                          {templateError}
                        </div>
                      )}
                    </div>
                  )}

                  <div className="col-md-12 mt-3">
                    <label className="basic-text required">{t("Status")}</label>
                    <select
                      className={`select-dropdown form-select custom-input ${
                        statusError.length > 0 ? "input-error" : ""
                      }`}
                      name="status"
                      value={status}
                      onChange={(event) => {
                        setStatus(event.target.value);
                        setStatusError("");
                        setIsStateUpdated(true);
                      }}
                    >
                      <option value={0} disabled>
                        {t("Status")}
                      </option>
                      {statusList.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.value}
                          </option>
                        );
                      })}
                    </select>
                    {statusError.length > 0 && (
                      <div className="invalid-error px-0">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                          alt="invalid"
                        />
                        {statusError}
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="border-top "
                  style={{
                    position: "fixed",
                    width: "656px",
                    bottom: "0px",
                    right: getLanguage !== "ar" && "0px",
                    background: "#ffffff",
                    padding: "10px",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <button
                      className="secondary-md-btn btn ml-2"
                      onClick={() => {
                        onClose();
                        reset();
                      }}
                    >
                      {t("Cancel")}
                    </button>
                    <button
                      className="primary-lg-btn btn"
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      {t("Create")}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </Box>
        </div>
      </SwipeableDrawer>
    </div>
  );
};
